module.exports = __webpack_public_path__ + "static/media/apollo.1f0e993f.webp";